import { navigate } from "./navigation";

export const apiHelper = {
  handleError: (err) => {
    if (err?.response?.status === 401) {
      navigate(`/auth/sign-in?returnURL=${window.location.pathname}`);
    } else if (err?.response?.status === 404) {
      navigate("/error/404");
    } else if (err?.response?.status === 400 || err?.response?.status === 422) {
      throw err;
    } else {
      navigate("/error/500");
    }
  },
};
